"use client";
import React, { useEffect, useState } from "react";
// import { Image } from "antd";
// import { useSearchParams } from "next/navigation";
import "./VoiceAgentButton.scss";
import VoiceAgentPanel from "@/components/VoiceAgent/VoiceAgentPanel";
import VoiceAgentV2Page from "@/components/VoiceAgentV2/VoiceAgentV2Page";
// import robotLogo from "../../assets/images/defaultImages/robot.jpg";

const VoiceAgentButton = ({ variant = "floating" }) => {
  // const searchParams = useSearchParams();
  const [isMounted, setIsMounted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Path query kept commented. The homepage icon opens the v2 agent directly.
  // ?voice_agent=1 keeps the OpenAI agent. ?voice_agent=v2 uses ElevenLabs.
  // const voiceAgentParam = String(searchParams?.get("voice_agent") || "").toLowerCase();
  // const engine = voiceAgentParam === "v2" ? "v2" : "openai";
  const engine = "v2";
  const engineLabel = engine === "v2" ? "Connect Agent" : "OpenAI working";
  // const showVoiceAgent =
  //   engine === "v2" || ["1", "true", "yes"].includes(voiceAgentParam);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Close drawer if query param is removed
  // useEffect(() => {
  //   if (!showVoiceAgent && (isOpen || isMounted)) {
  //     setIsOpen(false);
  //     document.body.style.overflow = "";
  //     setIsMounted(false);
  //   }
  // }, [showVoiceAgent, isOpen, isMounted]);

  const openDrawer = () => {
    setIsMounted(true);
    if (engine !== "v2") {
      document.body.style.overflow = "hidden";
      // Next frame so CSS can animate from translateY(100%) → 0
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setIsOpen(true));
      });
      return;
    }
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
    if (engine !== "v2") {
      document.body.style.overflow = "";
    }
    // Wait for the slide-down animation before unmounting
    window.setTimeout(() => setIsMounted(false), engine === "v2" ? 500 : 340);
  };

  const toggleDrawer = () => {
    if (isOpen || isMounted) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  // if (!showVoiceAgent) {
  //   return null;
  // }

  return (
    <>
      <div
        className={`voice-agent-widget${
          variant === "header" ? " voice-agent-widget--header" : ""
        }`}
      >
        {/* <span className={`voice-agent-engine voice-agent-engine--${engine}`}>
          {engineLabel}
        </span> */}
        <button
          className={`voice-agent-button${isOpen ? " active" : ""}`}
          onClick={toggleDrawer}
          aria-label={`Open voice agent, ${engineLabel}`}
          title={engineLabel}
          type="button"
        >
          {/* <Image
            preview={false}
            src={robotLogo.src}
            alt="Voice Agent"
            className="voice-agent-gif"
          /> */}
          <span className="voice-agent-call" aria-hidden="true">
            <svg viewBox="0 0 24 24" className="voice-agent-call-icon">
              <path
                d="M7.2 3.6c.4-.4 1-.5 1.5-.3l2.1.9c.5.2.8.7.8 1.2l-.2 2.2c0 .4-.2.8-.6 1L9.2 10c.8 1.6 2.1 2.9 3.7 3.7l1.4-1.6c.2-.4.6-.6 1-.6l2.2-.2c.5 0 1 .3 1.2.8l.9 2.1c.2.5.1 1.1-.3 1.5l-1.3 1.3c-.4.4-1 .6-1.6.5-3.1-.5-5.9-2.1-8.1-4.3S4.7 9.1 4.2 6c-.1-.6.1-1.2.5-1.6L7.2 3.6Z"
                fill="currentColor"
              />
              <path
                d="M16.2 4.2a5.2 5.2 0 0 1 3.6 3.6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
              <path
                d="M15.2 6.4a2.6 2.6 0 0 1 1.6 1.6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </span>
        </button>
      </div>

      {engine === "v2" && isMounted ? (
        <VoiceAgentV2Page open={isOpen} onClose={closeDrawer} />
      ) : null}

      {engine !== "v2" && isMounted && (
        <div
          className={`voice-agent-overlay${isOpen ? " open" : ""}`}
          onClick={closeDrawer}
        >
          <div
            className={`voice-agent-drawer${isOpen ? " open" : ""}`}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Voice support"
          >
            <VoiceAgentPanel onClose={closeDrawer} engine={engine} />
          </div>
        </div>
      )}
    </>
  );
};

export default VoiceAgentButton;
